import Routes from './routes'
import { render } from 'react-dom'
import '../../scss/application.scss'

render(Routes, document.getElementById('root'))
